// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Master .iq-user-box1 {
    
    margin-right: 10px;
    border-radius: 5px;
    padding: 2px;
    min-width: 35px;
    text-align: center;
    background: #20c997 !important;
}
.Master .iq-user-box2 {
    
    margin-right: 10px;
    border-radius: 5px;
    padding: 2px;
    min-width: 35px;
    text-align: center;
    background: #24c0d9 !important;
}
.Master .iq-user-box3 {
    
    margin-right: 10px;
    border-radius: 5px;
    padding: 2px;
    min-width: 35px;
    text-align: center;
    background: hsl(39deg 67.42% 58.25%) !important;
}
.Master .iq-user-box4 {
    
    margin-right: 10px;
    border-radius: 5px;
    padding: 2px;
    min-width: 35px;
    text-align: center;
    background: #17a2b8 !important;
}
.Master .iq-user-box5 {
    
    margin-right: 10px;
    border-radius: 5px;
    padding: 2px;
    min-width: 35px;
    text-align: center;
    background: #6c757d !important;
}


span.bg-warning.video_active {
    padding: 10px;
}


.Master .nav-link.active {
   /* font-size: 16px; */
      border-bottom: 2px solid #006aff !important;
    font-weight: 500;
    color: #fff !important;

}
.Master .nav-link {
    border-bottom: transparent;
    font-weight: 500;
    color: #000000;
    background-color: transparent;
    padding: 10px 60px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Video/Video_Management/Mastervideolist.css"],"names":[],"mappings":"AAAA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,8BAA8B;AAClC;AACA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,8BAA8B;AAClC;AACA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,+CAA+C;AACnD;AACA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,8BAA8B;AAClC;AACA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,8BAA8B;AAClC;;;AAGA;IACI,aAAa;AACjB;;;AAGA;GACG,qBAAqB;MAClB,2CAA2C;IAC7C,gBAAgB;IAChB,sBAAsB;;AAE1B;AACA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;IACd,6BAA6B;IAC7B,kBAAkB;AACtB","sourcesContent":[".Master .iq-user-box1 {\n    \n    margin-right: 10px;\n    border-radius: 5px;\n    padding: 2px;\n    min-width: 35px;\n    text-align: center;\n    background: #20c997 !important;\n}\n.Master .iq-user-box2 {\n    \n    margin-right: 10px;\n    border-radius: 5px;\n    padding: 2px;\n    min-width: 35px;\n    text-align: center;\n    background: #24c0d9 !important;\n}\n.Master .iq-user-box3 {\n    \n    margin-right: 10px;\n    border-radius: 5px;\n    padding: 2px;\n    min-width: 35px;\n    text-align: center;\n    background: hsl(39deg 67.42% 58.25%) !important;\n}\n.Master .iq-user-box4 {\n    \n    margin-right: 10px;\n    border-radius: 5px;\n    padding: 2px;\n    min-width: 35px;\n    text-align: center;\n    background: #17a2b8 !important;\n}\n.Master .iq-user-box5 {\n    \n    margin-right: 10px;\n    border-radius: 5px;\n    padding: 2px;\n    min-width: 35px;\n    text-align: center;\n    background: #6c757d !important;\n}\n\n\nspan.bg-warning.video_active {\n    padding: 10px;\n}\n\n\n.Master .nav-link.active {\n   /* font-size: 16px; */\n      border-bottom: 2px solid #006aff !important;\n    font-weight: 500;\n    color: #fff !important;\n\n}\n.Master .nav-link {\n    border-bottom: transparent;\n    font-weight: 500;\n    color: #000000;\n    background-color: transparent;\n    padding: 10px 60px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
